import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { resetPassword } from '../http/userAPI';
import { useNavigate, useLocation } from 'react-router-dom';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Получаем токен из query-параметра
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess('');
    setError('');
    if (password !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }
    if (!token) {
      setError('Некорректная или устаревшая ссылка для сброса пароля');
      return;
    }
    setLoading(true);
    try {
      await resetPassword(token, password);
      setSuccess('Пароль успешно изменён! Теперь вы можете войти с новым паролем.');
    } catch (e) {
      setError(e?.response?.data?.message || 'Ошибка при смене пароля');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center auth-container" style={{ minHeight: '100vh' }}>
      <Card className="p-4 auth-card">
        <h2 className="m-auto mb-4">Смена пароля</h2>
        <Form className="d-flex flex-column gap-3" onSubmit={handleSubmit}>
          <Form.Control
            placeholder="Введите новый пароль"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <Form.Control
            placeholder="Повторите новый пароль"
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
          />
          <Button type="submit" variant="outline-primary" disabled={loading}>
            {loading ? 'Сохранение...' : 'Сменить пароль'}
          </Button>
          {success && <Alert variant="success">{success}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}
        </Form>
        <div className="mt-3 text-center">
          <Button variant="link" onClick={() => navigate('/login')}>Вернуться к входу</Button>
        </div>
      </Card>
    </Container>
  );
};

export default ResetPassword; 